import type { SVGProps } from 'react';
import ZepIcon from '../ZepIcon';
export const OptionVerticalIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path fill={props.fill || `currentColor`} d="M14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0M14 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0M14 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0" />
  </svg>);